export default "__VITE_PUBLIC_ASSET__cff58840__"